import { Link } from 'react-router-dom';
import { MapPinOff } from 'lucide-react';
import { Card, EtatVide } from '@/shared/ui';

export function IntrouvablePage() {
  return (
    <Card>
      <EtatVide icone={MapPinOff} titre="Cette page n’existe pas">
        <p>L’adresse est peut-être incomplète, ou l’écran a changé de place.</p>
        <Link to="/" className="mt-4 inline-block font-medium text-primary">
          Revenir à l’accueil
        </Link>
      </EtatVide>
    </Card>
  );
}
